import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../../components/Layouts/Card';
import { Stack, TableToolbar, TableToolbarContent, Button, DatePicker, DatePickerInput, Select, SelectItem } from "@carbon/react";
import { DataTable as ListChecked } from "@carbon/icons-react";
import Typography from "../../../components/Basics/Typography";
import CarbonTableComponent from "../../../components/Basics/Table.container";
import { spacing05 } from "@carbon/themes";
import { onGetFatigueThunk } from '../../User/Recomendations/Recomendations.actions'
import { onGetStateAdasThunk } from './Camera.actions'; // IMPORTAR LA ACCIÓN
import LoadingContent from "../../../components/Animations/LoadingContent";
import InformationContainer from "../../../components/Basics/Information.container";
import { TopFilter2 } from "../../Productivity/Idle/Idle.styles";
import SearchTable from '../../../components/Basics/SearchTable.container';

/**
 * The recomendation's container.
 */
const CameraContainer = () => {
    const { loading_fatigue, fatigue } = useSelector(state => state.user);
    const { loading_state, lista } = useSelector(state => state.Camera);
    const dispatch = useDispatch();

    // Determinar valores predeterminados basados en la lógica de la acción
    const now = new Date();
    const hour = now.getHours();
    const defaultShift = hour >= 9 && hour <= 21 ? 'turno_noche' : 'turno_dia';
    const defaultDate = hour < 9 ? new Date(now.setDate(now.getDate() - 1)) : now;

    // Estados para los filtros
    const [selectedDate, setSelectedDate] = useState(defaultDate);
    const [selectedShift, setSelectedShift] = useState(defaultShift);
    const [tableRows_2, setTableRows_2] = useState([
        { id: 'row-1', name: '865326068612046', status: "TPYZ25", example: 'Camioneta' },
        { id: 'row-2', name: '865326068599433', status: "TPSF38", example: 'Camioneta' },
        { id: 'row-3', name: '865326062158657', status: "TCRX90", example: 'Bus' },
        { id: 'row-4', name: '865326062170108', status: "RXLY28", example: 'Camion Tolva' },
        { id: 'row-5', name: '865326068603870', status: "TFLS23", example: 'Minibus' },
        { id: 'row-6', name: '865326062153674', status: "SWJZ82", example: 'Camion Tolva' },
    ]);

    // NUEVO ESTADO PARA LAS FILAS DE SearchTable
    const [searchTableRows, setSearchTableRows] = useState([]);

    // DEFINIR HEADERS PARA SearchTable (ajustados a los campos reales del API)
    const searchTableHeaders = [
        { key: 'patent', header: 'Patente' },
        { key: 'deviceId', header: 'Device ID' },
        { key: 'type', header: 'Tipo' },
        { key: 'name', header: 'Nombre' },
        { key: 'surname', header: 'Apellido' },
        { key: 'geofenceName', header: 'Geocerca' },
        { key: 'etiqueta', header: 'Tipo de alerta' },
        { key: 'time', header: 'Fecha/Hora' },
        { key: 'vo', header: 'Odómetro (m)' },
        { key: 'ultimoOdometro', header: 'Último Odómetro (m)' },
        { key: 'diferenciaVo', header: 'Diferencia Odómetro (m)' },
    ];

    const convertToCSV = (data) => {
        const headerMapping = {
            'name': 'device_id',
            'status': 'patente',
            'example': 'tipo_equipo'
        };
        if (data.length === 0) {
            return '';
        }
        const headers = Object.values(headerMapping).join(',') + '\n';
        const rows = data.map(row => {
            return Object.keys(headerMapping).map(key => {
                let value = row[key];
                if (!isNaN(value) && value.toString().indexOf('.') !== -1) {
                    value = value.toString().replace('.', ',');
                }
                return `"${value}"`;
            }).join(',');
        }).join('\n');
        return headers + rows;
    };

    const downloadCSV = (csvContent, fileName = 'download.csv') => {
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleDownload = () => {
        const csv = convertToCSV(tableRows_2);
        downloadCSV(csv, 'estado_camaras.csv');
    };

    const handleDateChange = (date) => {
        setSelectedDate(date[0]);
    };

    const handleShiftChange = (e) => {
        setSelectedShift(e.target.value);
    };

    const applyFilters = () => {
        const formattedDate = selectedDate
            ? selectedDate.toISOString().split('T')[0]
            : null;
        const params = {
            date: formattedDate,
            current_turn: selectedShift,
        };
        dispatch(onGetFatigueThunk(params));
    };

    // Función para formatear timestamp a fecha legible
    const formatTimestamp = (timestamp) => {
        if (!timestamp) return 'N/A';
        const date = new Date(timestamp);
        return date.toLocaleString('es-CL', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    };

    useEffect(() => {
        dispatch(onGetFatigueThunk());
        dispatch(onGetStateAdasThunk());
    }, [dispatch]);

    useEffect(() => {
        if (fatigue && fatigue.length > 0) {
            const updatedTableRows_2 = fatigue.map((item, index) => ({
                id: `row-${index + 1}`,
                name: item.device_id,
                status: item.patente,
                example: item.tipo,
            }));
            setTableRows_2(updatedTableRows_2);
        }
    }, [fatigue]);

    // NUEVO useEffect PARA TRANSFORMAR lista A searchTableRows
    useEffect(() => {
        if (lista && lista.length > 0) {
            const transformedRows = lista.map((item, index) => ({
                id: item.id || `row-${index + 1}`,
                patent: item.patent || 'N/A',
                deviceId: item.device_id || 'N/A',
                type: item.type || 'N/A',
                name: item.name || 'Sin Registro',
                surname: item.surname || 'Sin Registro',
                geofenceName: item.geofence_name || 'Sin Registro',
                etiqueta: item.Etiqueta || 'N/A',
                time: formatTimestamp(item.time),
                vo: item.vo || 'N/A',
                ultimoOdometro: item.ultimo_odometro !== null ? item.ultimo_odometro : 'N/A',
                diferenciaVo: item.diferencia_vo !== null ? item.diferencia_vo : 'N/A',
            }));
            setSearchTableRows(transformedRows);
        }
    }, [lista]);

    return (
        <>
            {(loading_fatigue || loading_state) ? (
                <LoadingContent />
            ) : (
                <Stack gap={3}>
                    <Card justifyContent='flex-start'>
                        <ListChecked size={18} />
                        <Typography className='cds--type-heading-compact-01'>
                            EQUIPOS CON ÚLTIMO TURNO SIN EVENTOS DE FATIGA - TABLA DE DATOS
                        </Typography>
                    </Card>
                    <InformationContainer description="La tabla muestra equipos que han estado operativos y que no han enviado advertencias o alertas durante su último turno." />
                    <Card justifyContent='flex-start' padding={spacing05} flexDirection="column" style={{ width: '100%' }}>
                        <TopFilter2>
                            <DatePicker datePickerType="single" onChange={handleDateChange} value={selectedDate} dateFormat='d-m-Y' locale="es">
                                <DatePickerInput placeholder="dd/mm/yyyy" labelText="Fecha" id="daily-datepicker" size="md" />
                            </DatePicker>
                            <Select id="shift-select" labelText="Turno" defaultValue={selectedShift} onChange={handleShiftChange} size="sm">
                                <SelectItem text="Día" value="turno_dia" />
                                <SelectItem text="Noche" value="turno_noche" />
                            </Select>
                            <Button onClick={applyFilters}>Aplicar Filtros</Button>
                        </TopFilter2>
                        <TableToolbar>
                            <TableToolbarContent>
                                <Button onClick={handleDownload}>Descargar</Button>
                            </TableToolbarContent>
                        </TableToolbar>
                        <CarbonTableComponent
                            headers={[
                                "Device_id",
                                "Patente",
                                "Tipo de equipo"
                            ]}
                            rows={
                                tableRows_2.map((row) => [
                                    row.name,
                                    row.status,
                                    row.example
                                ])
                            }
                        />
                    </Card>

                    {/* NUEVA SECCIÓN CON SearchTable - REEMPLAZA EL IFRAME */}
                    <Card justifyContent='flex-start'>
                        <ListChecked size={18} />
                        <Typography className='cds--type-heading-compact-01'>
                            ÚLTIMO DATO DE ADAS DE CADA EQUIPO - TABLA DE DATOS
                        </Typography>
                    </Card>
                    <InformationContainer description="La tabla muestra el último dato ADAS de cada equipo que se haya recibido datos." />
                    <Card justifyContent='flex-start' padding={spacing05} flexDirection="column" style={{ width: '100%' }}>
                        <SearchTable
                            title="Datos Históricos ADAS"
                            rows={searchTableRows}
                            headers={searchTableHeaders}
                            downloadFileName="ultimo_dato_adas.csv" 
                        />
                    </Card>
                </Stack>
            )}
        </>
    )
}

export default CameraContainer